<!-- 业务商品期初 -->
<template>
    <div>
        <div>
            <div class="demo-drawer__content data_action_form">
                <div class="page_title">
                    <el-alert :title="dataActionBox.boxTitle" type="success" effect="dark" :closable="false">
                    </el-alert>
                </div>

                <el-tabs type="border-card" v-model="showTabs" class="el-tabs--border-card_new">
                    <el-tab-pane v-for="(formListValue, formKey) in tabForm" :key="formKey" :label="formListValue.jciName"
                        :name="formListValue.jciName">
                        <div v-if="formListValue.isShowForm != 1" class="table_content_box">
                            <!-- 主要信息 -->
                            <div v-if="formKey == 0">
                                <el-form label-width="150px" class="baseForm" :show-message="false" id="mainInfo"
                                    :model="sendDataInfo" ref="sendDataInfo" size="mini">
                                    <el-row ref="baseForm" v-if="dataActionBox.actionType != 2">
                                        <el-form-item :label="formOneValue.showField" :prop="formOneValue.entityField"
                                            v-for="(formOneValue, formOneKey) in formListValue.jurconfigform"
                                            :key="formOneKey" v-if="formOneValue.isShow == 1"
                                            :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []">
                                            <df-date :isShowLong="false"
                                                @keyup.enter.native="nextFocus(formOneKey, formOneValue.focusField)"
                                                v-if="formOneValue.fieldType == 'date'"
                                                :isdisabled="formOneValue.isChange == 0 || (formOneValue.isUpdate == 0 && dataActionBox.actionType == 1)"
                                                v-model="sendDataInfo[formOneValue.entityField]"></df-date>
                                            <el-input v-else-if="formOneValue.fieldType == 'search'" clearable
                                                v-model="sendDataInfo[formOneValue.entityField]"
                                                :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                                @keyup.enter.native="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)"
                                                :disabled="formOneValue.isChange == 0 || (formOneValue.isUpdate == 0 && dataActionBox.actionType == 1)">
                                                <el-button
                                                    @click="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)"
                                                    slot="append" icon="el-icon-search"
                                                    :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 1">
                                                </el-button>
                                            </el-input>
                                            <!-- 业务部门 -->
                                            <el-input v-else-if="formOneValue.entityField == 'psbkmRemark'"
                                                @keyup.enter.native="nextFocus(formOneKey, formOneValue.focusField)"
                                                :disabled="formOneValue.isChange == 0 || (formOneValue.isUpdate == 0 && dataActionBox.actionType == 1)"
                                                v-model.trim="sendDataInfo[formOneValue.entityField]" type="textarea">
                                            </el-input>
                                            <el-input v-else v-model.trim="sendDataInfo[formOneValue.entityField]"
                                                @keyup.enter.native="nextFocus(formOneKey, formOneValue.focusField)"
                                                :disabled="formOneValue.isChange == 0 || (formOneValue.isUpdate == 0 && dataActionBox.actionType == 1)"
                                                :maxlength="$store.state.inputLength"></el-input>
                                        </el-form-item>
                                    </el-row>
                                    <el-row ref="baseForm" v-if="dataActionBox.actionType == 2">
                                        <el-form-item :label="formOneValue.showField + ':'" :prop="formOneValue.entityField"
                                            v-if="formOneValue.isShow == 1"
                                            v-for="(formOneValue, formOneKey) in formListValue.jurconfigform"
                                            :key="formOneKey">
                                            <span v-if="formOneValue.fieldType == 'date'">
                                                {{ $common.getLocalTime(sendDataInfo[formOneValue.entityField]) }}
                                            </span>
                                            <span v-else-if="formOneValue.isRift == 1">
                                                <a
                                                    @click="toDetail(sendDataInfo[formOneValue.riftField])">{{ sendDataInfo.smName }}</a>
                                            </span>
                                            <span v-else>{{ sendDataInfo[formOneValue.entityField] }}</span>

                                        </el-form-item>
                                    </el-row>
                                </el-form>

                                <el-form :inline="true" size="mini" id="mxForm">
                                    <div style="margin-bottom: 0.5rem;" v-if="dataActionBox.actionType != 2">
                                        <el-button type="primary" size="mini" @click="addDetail('sendDataInfo')">新增明细
                                        </el-button>
                                        <el-button type="primary" size="mini" @click="deleteDetails()">删除</el-button>
                                    </div>
                                    <el-table :data="sendDataInfo.dewsuBeginDetailAdd" size="mini" :height="mxHeight" border
                                        :row-class-name="rowClassName" class="baseTable" :row-style="rowStyle"
                                        @row-click="clickEvent" ref="mxTableRef" @selection-change="handleSelectionChange"
                                        style="width: 100%">
                                        <el-table-column label="选择操作" width="80" v-if="dataActionBox.actionType != 2">
                                            <template slot-scope="scope">
                                                <el-radio v-model="selectedDetailsIndex" :label="scope.$index" border
                                                    size="mini">
                                                    <i class="el-icon-thumb"></i>
                                                </el-radio>
                                            </template>
                                        </el-table-column>
                                        <el-table-column :prop="formOneValue.entityField"
                                            :min-width="formOneValue.fieldWeight" show-overflow-tooltip
                                            v-if="formOneValue.isShow == 1" :label="formOneValue.showField"
                                            v-for="(formOneValue, formOneKey) in mxForm" :key="formOneKey">
                                            <template slot-scope="scope">
                                                <el-input
                                                    v-if="formOneValue.fieldType == 'search' && dataActionBox.actionType != 2 && formOneValue.isChange == 1"
                                                    clearable v-model="scope.row[formOneValue.entityField]"
                                                    :ref="formOneValue.entityField"
                                                    @keyup.enter.native="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, formOneValue.setField, formOneValue.focusField)">
                                                    <el-button
                                                        @click="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, formOneValue.setField, formOneValue.focusField)"
                                                        slot="append" icon="el-icon-search">
                                                    </el-button>
                                                </el-input>
                                                <!-- 库房 -->
                                                <!-- <el-select v-else-if="formOneValue.entityField == 'stId'" :disabled="dataActionBox.actionType == 2"
													v-model="sendDataInfo.dewsuBeginDetailAdd[scope.$index][formOneValue.entityField]">
													<el-option
														v-for="(storageRoomValue,storageRoomKey) in storageRoomList"
														:key="storageRoomKey" :label="storageRoomValue.stName"
														:value="storageRoomValue.stId">
													</el-option>
												</el-select> -->
                                                <!-- 数量 -->
                                                <el-input @input="calculatePrice(5, scope.$index)"
                                                    v-else-if="formOneValue.entityField == 'psbkdIsnumber' && dataActionBox.actionType != 2 && formOneValue.isChange == 1"
                                                    type="number"
                                                    @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)"
                                                    :ref="formOneValue.entityField"
                                                    v-model="sendDataInfo.dewsuBeginDetailAdd[scope.$index][formOneValue.entityField]">
                                                </el-input>
                                                <df-date
                                                    v-else-if="formOneValue.entityField == 'prodate' && dataActionBox.actionType != 2 && formOneValue.isChange == 1"
                                                    :isShowLong="false"
                                                    @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)"
                                                    :ref="formOneValue.entityField"
                                                    v-model="sendDataInfo.dewsuBeginDetailAdd[scope.$index][formOneValue.entityField]">
                                                </df-date>
                                                <!-- 有效期 -->
                                                <df-date
                                                    v-else-if="formOneValue.entityField == 'expidate' && dataActionBox.actionType != 2 && formOneValue.isChange == 1"
                                                    @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)"
                                                    :ref="formOneValue.entityField"
                                                    v-model="sendDataInfo.dewsuBeginDetailAdd[scope.$index][formOneValue.entityField]">
                                                </df-date>
                                                <!-- 单价 -->
                                                <el-input @input="calculatePrice(1, scope.$index)"
                                                    v-else-if="formOneValue.entityField == 'price' && dataActionBox.actionType != 2 && formOneValue.isChange == 1"
                                                    @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)"
                                                    :ref="formOneValue.entityField" :maxlength="$store.state.inputLength"
                                                    type="number"
                                                    v-model="sendDataInfo.dewsuBeginDetailAdd[scope.$index][formOneValue.entityField]">
                                                </el-input>

                                                <!-- 含税价 -->
                                                <el-input @input="calculatePrice(2, scope.$index)"
                                                    v-else-if="formOneValue.entityField == 'psprice' && dataActionBox.actionType != 2 && formOneValue.isChange == 1"
                                                    @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)"
                                                    :ref="formOneValue.entityField" :maxlength="$store.state.inputLength"
                                                    type="number"
                                                    v-model="sendDataInfo.dewsuBeginDetailAdd[scope.$index][formOneValue.entityField]">
                                                </el-input>

                                                <!-- 金额 -->
                                                <el-input @input="calculatePrice(3, scope.$index)"
                                                    v-else-if="formOneValue.entityField == 'money' && dataActionBox.actionType != 2 && formOneValue.isChange == 1"
                                                    @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)"
                                                    :ref="formOneValue.entityField" :maxlength="$store.state.inputLength"
                                                    type="number"
                                                    v-model="sendDataInfo.dewsuBeginDetailAdd[scope.$index][formOneValue.entityField]">
                                                </el-input>

                                                <!-- 含税金额 -->
                                                <el-input @input="calculatePrice(4, scope.$index)"
                                                    v-else-if="formOneValue.entityField == 'psmoney' && dataActionBox.actionType != 2 && formOneValue.isChange == 1"
                                                    @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)"
                                                    :ref="formOneValue.entityField" :maxlength="$store.state.inputLength"
                                                    type="number"
                                                    v-model="sendDataInfo.dewsuBeginDetailAdd[scope.$index][formOneValue.entityField]">
                                                </el-input>
                                                <el-input :disabled="dataActionBox.actionType == 2"
                                                    v-else-if="dataActionBox.actionType != 2 && formOneValue.isChange == 1"
                                                    v-model.trim="sendDataInfo.dewsuBeginDetailAdd[scope.$index][formOneValue.entityField]"
                                                    :maxlength="$store.state.inputLength"></el-input>
                                                <span
                                                    v-else-if="dataActionBox.actionType == 2 && formOneValue.fieldType == 'date'">
                                                    {{ $common.getLocalTime(sendDataInfo[formOneValue.entityField]) }}
                                                </span>
                                                <span v-else>{{ scope.row[formOneValue.entityField] }}</span>
                                            </template>
                                        </el-table-column>

                                    </el-table>
                                </el-form>
                            </div>
                        </div>
                    </el-tab-pane>
                </el-tabs>
                <div class="foot">
                    <div>
                        <el-button v-if="dataActionBox.actionType == 2 && $common.checkIsPrint()" type="primary"
                            @click="showPrintPlan">打印
                        </el-button>
                        <el-button type="primary" @click="initActionBox('sendDataInfo')"
                            v-if="dataActionBox.actionType != 2">取消</el-button>
                        <el-button type="primary" @click="sendDataAction('sendDataInfo')"
                            v-if="dataActionBox.actionType == 0">保存</el-button>
                        <el-button type="primary" @click="sendDataAction('sendDataInfo')"
                            v-if="dataActionBox.actionType == 1">保存</el-button>
                    </div>
                    <el-form :inline="true" :model="sendDataInfo" class="demo-form-inline ml" v-if="footForm">
                        <el-form-item :label="itemV.chineseField" v-for="(itemV, itemK) in footForm" :key="itemK">
                            <el-button type="success">{{ sendDataInfo[itemV.entityField] }}</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>

        </div>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth"
            :modal-append-to-body='true' :append-to-body="true" @close="closeChild">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel"
                @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <printPlan ref="printPlan"></printPlan>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../byComponents/SearchScheme.vue";
import NP from "number-precision";
export default {
    name: "businessGoodsInit",
    props: ['actionData'],
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchScheme,
    },
    data() {
        //这里存放数据
        return {
            selectDataTable: false,
            searchInfo: {
                name: "",
            },
            dataActionBox: {
                showStatus: false,
                openMode: "ltr" || "rtl",
                boxTitle: "新增" || "编辑",
                actionType: 0, // 0新增，1修改
            },
            sendDataInfo: {
                salesId: "",
                salesName: "",
                depId: "",
                depName: "",
                dewsuBeginDetailAdd: [],
                psbkmBusdept: "",
                depName: "",
                psbkmBuycus: "",
                smName: "",
                smId: "",
                coId: "",
                coName: "",
                opmId: "",
                opmName: "",
                psbkmPurchaser: "",
                psbkmRemark: "",
                psbkmRedate: "",
                psbkmSsalesman: "",
                seTitle: "",
                totalCount: 0,
                totalMoney: 0,
                totalNumber: 0,
                coName: "",
                coId: "",
                psaiAccperiod: "",
                psaiCarricus: "",
                psaiCarrier: "",
                psaiDeptime: 0,
                psaiExptime: 0,
                psaiPaymethod: "",
                psaiReserves1: "",
                psaiReserves2: "",
                psaiReserves3: "",
                psaiReserves4: "",
                psaiReserves5: "",
                psaiReserves6: "",
                psaiSettmethod: "",
                payMethod: '',
                settleMethod: ''
            },
            selectedDetailsIndex: 0,
            seWidth: "",
            showTabs: "",
            formDataList: [],
            salesmanList: [],
            DialogVisible: false,
            smId: "",
            seTitle: "",
            parentSearchData: {
                smId: "",
            },
            mxHeight: 400,
            mxForm: [],
            tabForm: [],
            footForm: [],
            detaislDataInfo: {
                bgmId: "",
                bgmName: "",
                inRate: 0,
                money: 0,
                psbkdIsnumber: 0,
                price: 0,
                psodPsdvolume: 0,
                psodPslowerlimit: 0,
                psmoney: 0,
                psodPsnvolume: 0,
                psprice: 0,
                // 进项税率
                inRate: 0,
                psodPsupperlimit: 0,
                psodReserves1: "",
                psodReserves2: "",
                psodReserves3: "",
                psodReserves4: "",
                psodReserves5: "",
                psodReserves6: "",
                psomId: "",
                pspdId: "",
                stId: "",
                depId: "",
            },
            selectedRow: [], // 当前已选择行
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        "sendDataInfo.dewsuBeginDetailAdd": {
            handler: function (newValue, oldValue) {
                this.sendDataInfo.totalMoney = 0;
                this.sendDataInfo.totalNumber = 0;
                this.sendDataInfo.totalCount = 0;
                newValue.forEach((item, keys) => {
                    console.log(item, "item");
                    for (let key in item) {
                        if (item[key] == null || item[key] == 'null') {
                            this.sendDataInfo.dewsuBeginDetailAdd[keys][key] = ''
                        }
                    }
                    let a = item.psbkdIsnumber;
                    if (item.psbkdIsnumber == "") {
                        item.psbkdIsnumber = 0;
                    } else if (a.length > 1 && a.substring(0, 1) == "0" && a.substring(1, 2) != ".") {
                        item.psbkdIsnumber = a.substring(1, a.length);
                    }
                    let b = item.psprice;
                    if (item.psprice == "") {
                        item.psprice = 0;
                    } else if (b.length > 1 && b.substring(0, 1) == "0" && b.substring(1, 2) != ".") {
                        item.psprice = b.substring(1, b.length);
                    }
                    if (item.psbkdIsnumber < 0) {
                        this.sendDataInfo["dewsuBeginDetailAdd"][keys].psbkdIsnumber = 0;
                        return false;
                    }
                    if (item.price < 0) {
                        this.sendDataInfo["dewsuBeginDetailAdd"][keys].price = 0;
                        return false;
                    }
                    if (item.money < 0) {
                        this.sendDataInfo["dewsuBeginDetailAdd"][keys].money = 0;
                        return false;
                    }
                    if (item.psprice < 0) {
                        this.sendDataInfo["dewsuBeginDetailAdd"][keys].psprice = 0;
                        return false;
                    }
                    if (item.psmoney < 0) {
                        this.sendDataInfo["dewsuBeginDetailAdd"][keys].psmoney = 0;
                        return false;
                    }
                    this.sendDataInfo.totalMoney = this.$common.getDecimalInfo(
                        3,
                        NP.plus(this.sendDataInfo.totalMoney, item.psmoney)
                    );
                    this.sendDataInfo.totalNumber = this.$common.getDecimalInfo(
                        1,
                        NP.plus(this.sendDataInfo.totalNumber, item.psbkdIsnumber)
                    );
                });
                this.sendDataInfo.totalCount = newValue.length;
            },
            deep: true,
        },
    },
    //方法集合
    methods: {
        showPrintPlan() { // 打印方法
            // 调用全局方法 判断Websocket是否连接
            if (this.$printSocketApi.printExeMsg() != false) {
                // 选中的数据
                this.$refs.printPlan.openDia(this.actionData.orderId, this.actionData.printSouce, this.actionData.printJurId)
            } else {
                return
            }
        },
        // 子组件穿透方法
        toDetail(orderId) {
            if (this.dataActionBox.actionType != 2) this.$parent.$parent.toDetail(orderId)
            else this.$parent.$parent.$parent.toDetail(orderId)
        },
        // 获取业务员
        async getUnitSalesmanList() {
            this.salesmanList = [];
            let responseData = await this.$http.getUnitSalesmanList({
                ids: [this.sendDataInfo.psbkmBuycus],
            });
            if (responseData.status == 200) {
                this.salesmanList = responseData.result;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        addDetail(sendDataInfo) {
            this.$refs[sendDataInfo][0].validate((valid) => {
                if (valid) {
                    // this.detailsBox.title = "新增明细信息"
                    this.sendDataInfo.dewsuBeginDetailAdd.push(
                        JSON.parse(JSON.stringify(this.detaislDataInfo))
                    );
                    this.$nextTick(() => {
                        this.selectedDetailsIndex = Number(this.sendDataInfo.dewsuBeginDetailAdd.length - 1)
                        this.tableNextFocus('bgmName', this.selectedDetailsIndex)
                        let refsElTable = this.$refs.mxTableRef[0]
                        refsElTable.clearSelection();
                        refsElTable.toggleRowSelection(this.sendDataInfo.dewsuBeginDetailAdd[this.selectedDetailsIndex]);
                    })
                } else {
                    this.$message({
                        message: "请完善必填信息",
                        type: "error",
                    });
                    return false;
                }
            })
        },
        tableRowClassName({ row, rowIndex }) {
            row.index = rowIndex;
        },
        getSeWidth(e) {
            console.log(e);
            this.seWidth = e + "%";
        },
        getSearchName(e) {
            console.log(e);
            this.seTitle = e;
        },
        // 计算价格
        calculatePrice(cate, index) {
            var info = this.sendDataInfo.dewsuBeginDetailAdd[index];
            if (info.psbkdIsnumber <= 0) {
                this.$message({
                    message: "请先填写采购数量",
                    type: "error",
                });
                return false;
            }
            switch (cate) {
                case 1: // 单价计算
                    console.log(111);
                    // 计算含税价格 单价+单价*税率/100
                    var thisPrice = NP.plus(
                        info.price,
                        NP.divide(NP.times(info.price, info.inRate), 100)
                    );
                    console.log(thisPrice);
                    // this.detaislDataInfo.psprice  =  this.$common.getDecimalInfo(2,thisPrice)
                    this.sendDataInfo.dewsuBeginDetailAdd[index].psprice =
                        this.$common.getDecimalInfo(2, thisPrice);
                    // 计算金额 单价*数量
                    // this.detaislDataInfo.money  =  this.$common.getDecimalInfo(3,NP.times(info.price,info.psbkdIsnumber))
                    this.sendDataInfo.dewsuBeginDetailAdd[index].money =
                        this.$common.getDecimalInfo(
                            3,
                            NP.times(info.price, info.psbkdIsnumber)
                        );
                    // 计算含税金额 含税价格*数量
                    // this.detaislDataInfo.psmoney  =   this.$common.getDecimalInfo(3,NP.times(thisPrice,info.psbkdIsnumber))
                    this.sendDataInfo.dewsuBeginDetailAdd[index].psmoney =
                        this.$common.getDecimalInfo(
                            3,
                            NP.times(thisPrice, info.psbkdIsnumber)
                        );
                    break;
                case 2: // 含税价格计算
                    console.log(222);
                    // 计算单价 含税价格/(税率/100+1)
                    var thisPrice = NP.divide(
                        info.psprice,
                        NP.plus(NP.divide(info.inRate, 100), 1)
                    );
                    this.sendDataInfo.dewsuBeginDetailAdd[index].price =
                        this.$common.getDecimalInfo(2, thisPrice);
                    // 计算金额 单价*数量
                    this.sendDataInfo.dewsuBeginDetailAdd[index].money =
                        this.$common.getDecimalInfo(
                            3,
                            NP.times(thisPrice, info.psbkdIsnumber)
                        );
                    // 计算含税金额 含税价格*数量
                    this.sendDataInfo.dewsuBeginDetailAdd[index].psmoney =
                        this.$common.getDecimalInfo(
                            3,
                            NP.times(info.psprice, info.psbkdIsnumber)
                        );
                    break;
                case 3: // 通过总金额计算
                    console.log(333);
                    // 计算单价  总金额 / 数量
                    var thisPrice = NP.divide(info.money, info.psbkdIsnumber);
                    this.sendDataInfo.dewsuBeginDetailAdd[index].price =
                        this.$common.getDecimalInfo(2, thisPrice);
                    // 计算含税价格 单价+单价*税率/100
                    var thisPriceTwo = NP.plus(
                        thisPrice,
                        NP.divide(NP.times(thisPrice, info.inRate), 100)
                    );
                    this.sendDataInfo.dewsuBeginDetailAdd[index].psprice =
                        this.$common.getDecimalInfo(3, thisPriceTwo);
                    // 计算含税金额 含税价格*数量
                    this.sendDataInfo.dewsuBeginDetailAdd[index].psmoney =
                        this.$common.getDecimalInfo(
                            3,
                            NP.times(thisPriceTwo, info.psbkdIsnumber)
                        );
                    break;
                case 4: // 通过含税金额计算
                    console.log(444);
                    // 计算含税价格  含税金额 / 数量
                    var thisPrice = NP.divide(info.psmoney, info.psbkdIsnumber);
                    this.sendDataInfo.dewsuBeginDetailAdd[index].psprice =
                        this.$common.getDecimalInfo(2, thisPrice);
                    // 计算单价 含税价格/(税率/100+1)
                    var thisPriceTwo = NP.divide(
                        thisPrice,
                        NP.plus(NP.divide(info.inRate, 100), 1)
                    );
                    this.sendDataInfo.dewsuBeginDetailAdd[index].price =
                        this.$common.getDecimalInfo(2, thisPriceTwo);
                    // 计算总金额 单价*数量
                    this.sendDataInfo.dewsuBeginDetailAdd[index].money =
                        this.$common.getDecimalInfo(
                            3,
                            NP.times(thisPriceTwo, info.psbkdIsnumber)
                        );
                    break;
                default:
                    console.log('大范德萨范德萨发')
                    // 通过数量计算
                    // 计算金额 单价*数量
                    this.sendDataInfo.dewsuBeginDetailAdd[index].money =
                        this.$common.getDecimalInfo(
                            3,
                            NP.times(info.price, info.psbkdIsnumber)
                        );
                    // 计算含税金额 含税价格*数量
                    this.sendDataInfo.dewsuBeginDetailAdd[index].psmoney =
                        this.$common.getDecimalInfo(
                            3,
                            NP.times(info.psprice, info.psbkdIsnumber)
                        );
                    break;
            }
        },
        init() {
            for (let key in this.sendDataInfo) {
                if (key == "pisOrderAuxinfAdd") {
                    this.sendDataInfo[key];
                    for (let sonOne in this.sendDataInfo[key]) {
                        this.sendDataInfo[key][sonOne] = "";
                    }
                } else {
                    this.sendDataInfo[key] = "";
                }
            }

            this.sendDataInfo.psbkmRedate = this.$moment().valueOf();
            this.sendDataInfo.psaiDeptime = 0;
            this.sendDataInfo.psaiExptime = 0;
            this.sendDataInfo.dewsuBeginDetailAdd = [];
            this.sendDataInfo.psomIswmsm = 0;
            this.sendDataInfo.totalMoney = 0;
            this.sendDataInfo.totalCount = 0;
        },
        initActionBox(sendDataInfo) {
            this.$confirm("确定取消新增吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.$emit('drawerCancel')
                    this.init();
                    this.$refs.sendDataInfo[0].resetFields();
                })
                .catch(() => {
                    // this.$message({
                    //     type: 'info',
                    //     message: '取消关闭'
                    // });
                });
        },
        // 选择采购员
        selectUserOne(data) {
            data.forEach((item) => {
                if (item.opmId == this.sendDataInfo.psbkmPurchaser) {
                    console.log(item, "选择采购员");
                    this.sendDataInfo.psbkmBusdept = item.depId;
                    this.sendDataInfo.depName = item.depName;
                }
            });
        },

        openBox() {
            this.dataActionBox.actionType = this.actionData.cate
            this.formDataList = this.actionData.formData
            this.filterMainField()
            var oldData = this.actionData.oldData
            this.showTabs = this.actionData.formData[0].jciName
            this.init();
            if (this.dataActionBox.actionType == 0) {
                this.dataActionBox.boxTitle = "新增信息";
                this.dataActionBox.openMode = "ltr";
                this.parentSearchData.smId = "";
            } else if (this.dataActionBox.actionType == 2) {
                this.dataActionBox.boxTitle = '查看信息'
                var dataInfo = JSON.parse(JSON.stringify(oldData))
                for (let key in dataInfo) {
                    this.sendDataInfo[key] = dataInfo[key]
                }
                this.sendDataInfo.dewsuBeginDetailAdd = dataInfo.detailVoList
                // this.sendDataInfo.pisOrderAuxinfAdd = dataInfo.pisOrderauxinfVo
            }
            this.$nextTick(() => {
                console.log(this.$refs)
                var sheight = this.$refs.baseForm[0].$el.clientHeight
                if (this.dataActionBox.actionType != 2) { this.mxHeight = document.documentElement.clientHeight - sheight - 240 }
                else { this.mxHeight = document.documentElement.clientHeight - sheight - 260 }
                this.initFocus()
            })
        },
        async sendDataAction(sendDataInfo) {
            this.$refs.sendDataInfo[0].validate((valid) => {
                if (valid) {
                    this.sub();
                } else {
                    return this.$message({
                        message: '请完善信息',
                        type: "error",
                    });
                }
            });
        },
        async sub() {
            var responseData = await this.$http.addBusinessGoodsEntry(
                this.sendDataInfo
            );

            if (responseData.status == 200) {
                this.$emit('drawerCancel')
                this.init();
                this.$refs.sendDataInfo[0].resetFields();
                this.$message({
                    message: "操作成功",
                    type: "success",
                });

            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        deleteDetails() {
            if (this.sendDataInfo.dewsuBeginDetailAdd.length > 0) {
                this.sendDataInfo.dewsuBeginDetailAdd.splice(this.selectedDetailsIndex, 1);
                this.$nextTick(() => {
                    if (this.sendDataInfo.dewsuBeginDetailAdd.length > 1) {
                        this.selectedDetailsIndex = Number(this.selectedDetailsIndex - 1)
                        this.tableNextFocus('bgmName', this.selectedDetailsIndex)
                        let refsElTable = this.$refs.mxTableRef[0]
                        refsElTable.clearSelection();
                        refsElTable.toggleRowSelection(this.sendDataInfo.dewsuBeginDetailAdd[this.selectedDetailsIndex]);
                    } else {
                        this.selectedDetailsIndex = 0
                    }
                })
            } else {
                return this.$message({
                    message: "暂无可删除明细",
                    type: "warning",
                });
            }

        },

        // 过滤表单不同类型
        filterMainField() {
            var mainFormList = []
            this.formDataList.forEach(item => {
                if (item.jciType == 1) {
                    mainFormList.push(item)
                } else if (item.jciType == 2) {
                    this.mxForm = JSON.parse(JSON.stringify(item.jurconfigform))
                } else if (item.jciType == 3) {
                    this.footForm = JSON.parse(JSON.stringify(item.jurconfigform))
                }
            })
            mainFormList.forEach((key, i) => {
                this.tabForm[i] = JSON.parse(JSON.stringify(key))
                this.tabForm[i].jurconfigform = []
                for (let index = 0; index < key.jurconfigform.length; index++) {
                    if (key.jurconfigform[index].isShow == 1) this.tabForm[i].jurconfigform.push(key.jurconfigform[index])
                }
            })
        },
        // 获取主表单所有input
        getMainInput() {
            var el = document.getElementById('mainInfo')
            if (el) this.inputel = el.getElementsByTagName('input')
        },
        // 初始化焦点
        initFocus() {
            for (let index = 0; index < this.inputel.length; index++) {
                if (this.inputel[index].value == '' && this.inputel[index].disabled == false) {
                    this.inputel[index].focus()
                    break
                }
            }
        },
        // 输入框切换焦点
        nextFocus(index) {
            if (index >= (this.inputel.length - 1)) return
            var aindex = index + 1
            if (this.inputel[aindex].value != '' || this.inputel[aindex].disabled) {
                this.nextFocus(aindex)
                return
            }
            this.inputel[aindex].focus()
        },
        //检索Id, 索引(表格中), 标识
        openSearch(sId, index, type, sField, fField) {
            this.DialogVisible = true;
            this.seId = sId;
            this.seIndex = index;
            this.seType = type;
            this.sField = sField;
            this.fField = fField
            if (type == 'bgmName' || type == 'stName') {
                this.parentSearchData[type] = this.sendDataInfo.dewsuBeginDetailAdd[this.seIndex][type]
                this.selectedDetailsIndex = this.seIndex
                let refsElTable = this.$refs.mxTableRef[0]
                refsElTable.clearSelection();
                refsElTable.toggleRowSelection(this.sendDataInfo.dewsuBeginDetailAdd[this.selectedDetailsIndex]);
                return
            }
            this.parentSearchData[type] = this.sendDataInfo[type]
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(',')
            arr.forEach(item => {
                this.sendDataInfo[item] = val[item]
            })
            this.$nextTick(() => {
                this.nextFocus(this.seIndex)
            })
        },
        changeInputModel(val) {
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                if (val.smId) {
                    this.parentSearchData.smId = val.smId;
                }
                if (this.seType == "bgmName") {
                    this.$set(
                        this.sendDataInfo.dewsuBeginDetailAdd,
                        this.seIndex,
                        JSON.parse(JSON.stringify(val))
                    );
                    this.sendDataInfo.dewsuBeginDetailAdd[this.seIndex].psodPsdvolume =
                        val.rjXl;
                    this.sendDataInfo.dewsuBeginDetailAdd[this.seIndex].psodPsnvolume =
                        val.stockNum;
                    this.sendDataInfo.dewsuBeginDetailAdd[this.seIndex].psodPsupperlimit =
                        val.limdHighnum;
                    this.sendDataInfo.dewsuBeginDetailAdd[this.seIndex].psodPslowerlimit =
                        val.limdLownum;
                    this.$nextTick(() => {
                        this.$set(
                            this.sendDataInfo.dewsuBeginDetailAdd[this.seIndex],
                            "psbkdIsnumber",
                            0
                        );
                        this.$set(
                            this.sendDataInfo.dewsuBeginDetailAdd[this.seIndex],
                            "psmoney",
                            0
                        );
                        this.$set(
                            this.sendDataInfo.dewsuBeginDetailAdd[this.seIndex],
                            "money",
                            0
                        );
                        this.$set(
                            this.sendDataInfo.dewsuBeginDetailAdd[this.seIndex],
                            "price",
                            0
                        );
                        this.$set(
                            this.sendDataInfo.dewsuBeginDetailAdd[this.seIndex],
                            "psprice",
                            0
                        );

                        this.tableNextFocus(this.fField, this.seIndex)
                        this.selectedDetailsIndex = this.seIndex
                        let refsElTable = this.$refs.mxTableRef[0]
                        refsElTable.clearSelection();
                        refsElTable.toggleRowSelection(this.sendDataInfo.dewsuBeginDetailAdd[this.selectedDetailsIndex]);
                    })
                } else if (this.seType == "stName") {
                    this.sendDataInfo.dewsuBeginDetailAdd[this.seIndex].stName = val.stName
                    this.sendDataInfo.dewsuBeginDetailAdd[this.seIndex].stId = val.stId
                } else {
                    this.paramValue(val)
                }
            }
        },
        // 表格方法
        rowClassName({ row, rowIndex }) {
            let rowName = "",
                findRow = this.selectedRow.find(c => c.rowIndex === row.rowIndex);
            if (findRow) {
                rowName = "rowStyle "; // 可以通过此处给选中行一个class，根据自己需求更改样式
            }
            return rowName; //也可以再加上其他类名 如果有需求的话
        },

        // 选中行底色逻辑
        rowStyle({ row, rowIndex }) {
            Object.defineProperty(row, "rowIndex", { // 给每行添加不可枚举属性rowIndex来标识当前行
                value: rowIndex,
                writable: true,
                enumerable: false
            });
        },

        // 明细表格点击选中
        clickEvent(row, column, event, params) {
            let refsElTable = this.$refs.mxTableRef[0]; // 获取表格对象
            let findRow = {}
            this.selectedDetailsIndex = row.rowIndex
            findRow = this.selectedRow.find(c => c.rowIndex == row.rowIndex); //找出当前选中行
            //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
            if (findRow && this.selectedRow.length === 1) {
                refsElTable.toggleRowSelection(row, false);
                return;
            }
            refsElTable.clearSelection();
            refsElTable.toggleRowSelection(row);
        },

        // 保存已选择行
        handleSelectionChange(rows) {
            this.selectedRow = rows; // 保存已选择行
        },
        // 表格切换焦点方法
        tableNextFocus(field, index) {
            console.log(field, index)
            this.seIndex = index
            if (field == 'keydown') {
                if (this.sendDataInfo.dewsuBeginDetailAdd[index + 1] != undefined) {
                    this.$refs['bgmName'][index + 1].focus()
                    this.selectedDetailsIndex = index + 1
                    this.$nextTick(() => {
                        let refsElTable = this.$refs.mxTableRef[0]
                        refsElTable.clearSelection();
                        refsElTable.toggleRowSelection(this.sendDataInfo.dewsuBeginDetailAdd[this.selectedDetailsIndex]);
                    })
                    return
                }
                this.addDetail('sendDataInfo')
                return
            }
            this.$refs[field][index].focus()
        },
        closeChild() {
            addEventListener('keyup', this.keyUp)//创建监听键盘事件
        },
        // 监听键盘事件
        keyUp(e) {
            if (e.key == 'F1') { // 右键新增明细
                e.preventDefault();
                this.addDetail('sendDataInfo')
                return
            } else if (e.key == 'F2') {
                e.preventDefault();
                this.deleteDetails()
            } else if (e.keyCode == 40) { // 下键
                // 表格为空，不执行下方 
                if (this.sendDataInfo.dewsuBeginDetailAdd.length == 0) return
                let refsElTable = this.$refs.mxTableRef[0]
                this.$nextTick(() => {
                    if (this.selectedRow.length == 0) { // 如果当前没有选中行，则直接选中第一个
                        this.selectedDetailsIndex = 0
                    } else if (this.selectedDetailsIndex == this.sendDataInfo.dewsuBeginDetailAdd.length - 1) { // 如果选中的是最后一行了，那么下一行选中的是第一行
                        this.selectedDetailsIndex = 0
                    } else { // 正常递增
                        this.selectedDetailsIndex++
                    }
                    if (!refsElTable) return
                    let findRow = this.selectedRow.find(c => c.rowIndex == this.selectedDetailsIndex); //找出当前选中行
                    //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
                    if (findRow && this.selectedRow.length === 1) {
                        refsElTable.toggleRowSelection(this.sendDataInfo.dewsuBeginDetailAdd[this.selectedDetailsIndex], false);
                        return;
                    }
                    // this.tableNextFocus('bgmName',this.selectedDetailsIndex)
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(this.sendDataInfo.dewsuBeginDetailAdd[this.selectedDetailsIndex]); // 把现在当前行勾选
                })
            } else if (e.keyCode == 38) { // 上键
                if (this.sendDataInfo.dewsuBeginDetailAdd.length == 0) return
                let refsElTable = this.$refs.mxTableRef[0]
                this.$nextTick(() => {
                    if (this.selectedRow.length == 0) { // 当前没有选中行，则直接选中第一个
                        this.selectedDetailsIndex = 0
                    } else if (this.selectedDetailsIndex == 0) { // 如果选中的是第一行了，那么下一行选中的是最后一行
                        this.selectedDetailsIndex = this.sendDataInfo.dewsuBeginDetailAdd.length - 1
                    } else { // 正常递减
                        this.selectedDetailsIndex--
                    }
                    if (!refsElTable) return
                    let findRow = this.selectedRow.find(c => c.rowIndex == this.selectedDetailsIndex); //找出当前选中行
                    //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
                    if (findRow && this.selectedRow.length === 1) {
                        refsElTable.toggleRowSelection(this.sendDataInfo.dewsuBeginDetailAdd[this.selectedDetailsIndex], false);
                        return;
                    }
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(this.sendDataInfo.dewsuBeginDetailAdd[this.selectedDetailsIndex]); // 把现在当前行勾选
                })
            }

        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.$nextTick(() => {
            this.openBox()
        })
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        // addEventListener('keydown', this.keyDown)
        addEventListener('keyup', this.keyUp)//创建监听键盘事件
    },
    beforeDestroy() {
        removeEventListener('keyup', this.keyUp)
    },
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() {
        this.getMainInput()
    }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_button_box {
    height: 200px;
    background-color: red;
}

.table_content_box {
    overflow-y: auto;
}

.foot {
    display: flex;
    justify-content: center;
    align-items: center;
    /* position: absolute;
    bottom: -27px;
    left: 49%;
    transform: translate(-50%, -50%); */
    width: 100%;
    background: #fff;
    padding: 14px 0;
    z-index: 999;
}

.foot .el-form {
    margin-left: 20px;
}

.foot .el-form .el-form-item {
    margin-bottom: 0;
}

#mxForm .el-date-editor.el-input,
#mxForm .el-date-editor.el-input__inner {
    width: 100%;
}

#mxForm .el-form-item--mini.el-form-item,
#mxForm .el-form-item--small.el-form-item {
    margin-bottom: 0;
}
</style>
<style>
.el-table .rowStyle {
    background: #FFF7CA !important;
}
</style>